export default __webpack_public_path__ + "static/media/loading.13aa4dee.svg";